import { Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as NewForm } from './new_form'

interface Props {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const NewDialog = ({ open, setOpen }: Props) => {
  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle>New warehouse</DialogTitle>
        <DialogBody>
          <NewForm onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
